
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
    },

    table: {
        backgroundColor: '#dcdcdc',
        padding: '1%',
      },

    main_header: {
        padding: '1%',
        marginBottom: '1%',
        backgroundColor: 'rgb(122, 101, 149)',
        color: 'white',
        textAlign:'center',
        fontSize:'150%',
        fontWeight:'bold'
    },

    items: {
        padding: '1%',
    },

    item_body: {
        paddingLeft: '2%',
        textAlign:'center',
        width:'50%'
      },

    input: {
        width: '50%',
    },
    
    item_header: {
        fontSize: '100%',
        fontWeight: 600,
        
        marginLeft:'10%'
    },

    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '2%',
    },

    check_list: {
        clear: 'both',
        marginLeft:'10%',
        paddingTop:'2%'

    },
    check_list_task:{
        width:'50%',
    },
    radio_button:{
        display:'flex',
        flexDirection:'row'
    }

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/checkin/style.js